import { Divider } from '@mui/material';
import InventorySection from 'src/components/dashboardComponents/InventorySection';
import OrderSection from 'src/components/dashboardComponents/orderSection';

export default function AdminDashboard() {
  return (
    <>
      <OrderSection />
      <Divider sx={{ mb: 4 }} />
      <InventorySection />
    </>
  );
}
